import React from 'react';
import Row from './row';
import './Table.css';

function Table({ headers, rowsClass = '', cellClass='', cellClass2='', cellClass2ConditionList={}, rows, columnWidths, idViewing, idArrayId, tableContainerClass = 'table-container', tableClass = 'table' }) {
  return (
      <div className={tableContainerClass}>
        <div className={tableClass}>
          {/* Nagłówki */}
          <div className="table-header">
            <Row columns={headers} columnWidths={columnWidths} idViewing={idViewing} idArrayId={idArrayId} />
          </div>
          {/* Wiersze */}
          <div className="table-body">
            {rows.map((row, index) => {
              const rowData = Array.isArray(row) ? { columns: row, rowClass: '' } : row;
              const combinedRowClass = `${rowsClass} ${rowData.rowClass || ''}`.trim();
              return (
                <Row
                  key={index}
                  columns={rowData.columns}
                  rowClass={combinedRowClass}
                  cellClass={cellClass}
                  cellClass2={cellClass2}
                  cellClass2ConditionList={cellClass2ConditionList}
                  columnWidths={columnWidths}
                  idViewing={idViewing}
                  idArrayId={idArrayId}
                />
              );
            })}
          </div>
        </div>
      </div>
  );
}

export default Table;
